import FooterSubmitButton from './FooterSubmitButton'

export default FooterSubmitButton
